export const cookieKeys = {
    searchView: 'tev_search_view',
    region: 'epv_user_region',
    clientIp: 'epv_ip',
}



// WEBPACK FOOTER //
// /data/web/app/themes/epv/bs-embeds/src/config/cookies.js